import { Action } from "redux";
import { ThunkAction } from "redux-thunk";
import { endpoints } from "../Constants/endpoints";
import { IAppState, ApiRequest } from "../../Common";
import ResponseHandler from "../../App/ResponseHandler";
import { WorkflowImage } from "../Models/WorkflowImage";
import { IconSet } from "../Models/IconSet";

interface IWorkflowImagesAction extends Action {
  type: WorkflowImagesActionType;
  payload: any;
}

// ARGUMENT TYPES
export interface IGetWorkflowImagesArguments {}
export interface ISetWorkflowImagesLoadingArguments {}
export interface ISetWorkflowImagesErroredArguments {
  errorMessage: string;
  errorCode: number;
}

// PAYLOAD TYPES

export interface IWorkflowImagesLoadedPayload {
  loadedImageSets: IconSet[];
}

export interface ISetWorkflowImagesLoadingPayload {}

export interface ISetWorkflowImagesErroredPayload {
  errorMessage: string;
  errorCode: number;
}

// ACTION TYPES

export interface IWorkflowImagesLoadedAction extends IWorkflowImagesAction {
  payload: IWorkflowImagesLoadedPayload;
}

export interface ISetWorkflowImagesLoadingAction extends IWorkflowImagesAction {
  payload: ISetWorkflowImagesLoadingPayload;
}

export interface ISetWorkflowImagesErroredAction extends IWorkflowImagesAction {
  payload: ISetWorkflowImagesErroredPayload;
}

// Union of all action types. Please add new actions here ;)
export type WorkflowImagesAction =
  | IWorkflowImagesLoadedAction
  | ISetWorkflowImagesLoadingAction
  | ISetWorkflowImagesErroredAction;

export enum WorkflowImagesActionType {
  WORKFLOW_IMAGES_LOADED = "WORKFLOW_IMAGES_LOADED",
  WORKFLOW_IMAGES_SET_LOADING = "WORKFLOW_IMAGES_SET_LOADING",
  WORKFLOW_IMAGES_SET_ERRORED = "WORKFLOW_IMAGES_SET_ERRORED"
}

export const setErrored = (
  args: ISetWorkflowImagesErroredArguments
): ISetWorkflowImagesErroredAction => ({
  type: WorkflowImagesActionType.WORKFLOW_IMAGES_SET_ERRORED,
  payload: { ...args }
});

export const getWorkflowImageSets = (
  args: IGetWorkflowImagesArguments
): ThunkAction<
  void,
  IAppState,
  {},
  IWorkflowImagesLoadedAction | ISetWorkflowImagesErroredAction
> => dispatch => {
  ApiRequest.fromPath(endpoints.images())
    .withAuthHeader()
    .get()
    .then(response => {
      ResponseHandler.handle(
        response,
        result => {
          // this was successful
          dispatch({
            type: WorkflowImagesActionType.WORKFLOW_IMAGES_LOADED,
            payload: {
              loadedImageSets: result.payload
            }
          });
        },
        result => {
          dispatch(setErrored({ errorCode: response.status, errorMessage: result.error.message }));
        },
        () => {
          dispatch(
            setErrored({
              errorCode: response.status,
              errorMessage: "An unknown error has occurred"
            })
          );
        }
      );
    });
};

export const setLoading = (
  args: ISetWorkflowImagesLoadingArguments
): ISetWorkflowImagesLoadingAction => ({
  type: WorkflowImagesActionType.WORKFLOW_IMAGES_SET_LOADING,
  payload: { ...args }
});
